import { StaticBooleanConditionSchema } from '../../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema';
import { IWidgetOptionValue } from '../../../../../Widget';

export const createDefaultOptionValue = (): IWidgetOptionValue => ({
  type: 'option',
  label: [{ type: 'text', text: '' }],
  value: '',
  visible: StaticBooleanConditionSchema.cast({}, { assert: false }),
  enabled: StaticBooleanConditionSchema.cast({}, { assert: false }),
});
